import * as Api from '@/utils/request'

export default {

    /**
     * 一些公用的比如点赞等接口
     * @returns {Promise.<*>}
     */

    //参数：id ：1263039，kind：live_msg (如果kind=live_msg，则表示点赞的是直播，id对应也是直播的id; 如果点赞专栏 kind也是live_msg，id为对应专栏id；如果点赞资讯 kind为express，id为对应资讯id)
    async addPraise(id, type) {
        return await Api.get({
            url: '/H5ReactLives/addPraise',
            params: { id, kind: type }
        })
    },
    async reduce(id, kind) {
        return await Api.get({
            url: '/H5ReactLives/reduce',
            params: {
                id,
                kind
            }
        })
    }

}